// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1314374d","977":"a2004dfd"}[chunkId] + ".chunk.js";
};